module.exports = "/_next/static/images/f5d8b10e6e76575712ab75e57bb71397-notaxes@0.75x.jpg.webp";